import { DENSITY_ROW_HEIGHT } from "@constants";
import { VIEW_DENSITY_BY_DENSITY } from "../adapters/savedViewDensity";
import type { DataGridDensity } from "../types";

/**
 * Row heights in px, shared with ViewTable through the saved view density.
 * The root writes them to `--dg-row-h`, so CSS and the virtualizer agree.
 */
export const ROW_HEIGHT_BY_DENSITY: Record<DataGridDensity, number> = {
    compact: DENSITY_ROW_HEIGHT[VIEW_DENSITY_BY_DENSITY.compact],
    default: DENSITY_ROW_HEIGHT[VIEW_DENSITY_BY_DENSITY.default],
    relaxed: DENSITY_ROW_HEIGHT[VIEW_DENSITY_BY_DENSITY.relaxed],
};

/** One header row: 32px plus its 1px bottom border. */
export const HEADER_ROW_HEIGHT = 33;

export const SKELETON_ROW_COUNT = 8;

/** Skeleton rows under the last row while load more fetches a batch. */
export const LOAD_MORE_ROW_COUNT = 3;

/** Locked placeholder rows under a gated table's call to action. */
export const GATE_ROW_COUNT = 5;
